import { createContext, useContext, useCallback, useEffect, useState } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

const CrmContext = createContext(null);

export function CrmProvider({ children }) {
  const { isTitolare, activeSettore } = useAuth();
  const [ssd, setSsd] = useState([]);
  const [collaboratori, setCollab] = useState([]);
  const [settings, setSettings] = useState(null);
  const [portfolio, setPortfolio] = useState([]);
  const [attivita, setAttivita] = useState([]);
  const [movimenti, setMovimenti] = useState([]);
  const [materiali, setMateriali] = useState([]);
  const [progetti, setProgetti] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    api.setSettore(activeSettore);
    const [s, c, st, p, a] = await Promise.all([
      api.listSsd(),
      api.listCollab(),
      api.getSettings(),
      api.listPortfolio(),
      api.listAttivita(),
    ]);
    const mat = await api.listMateriali().catch(() => []);
    const prg = await api.listProgetti().catch(() => []);
    const m = isTitolare ? await api.listMovimenti().catch(() => []) : [];
    setSsd(s);
    setCollab(c);
    setSettings(st);
    setPortfolio(p);
    setAttivita(a);
    setMovimenti(m);
    setMateriali(mat);
    setProgetti(prg);
    setLoading(false);
  }, [isTitolare, activeSettore]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = {
    ssd,
    collaboratori,
    settings,
    portfolio,
    attivita,
    movimenti,
    materiali,
    progetti,
    loading,
    activeSettore,
    refresh,
    setSettings,
    api,
  };

  return <CrmContext.Provider value={value}>{children}</CrmContext.Provider>;
}

export const useCrm = () => useContext(CrmContext);

export function collabById(collaboratori, id) {
  return collaboratori.find((c) => c.id === id);
}

// Combined SSD options for activity selectors (portfolio + pipeline)
export function ssdOptions(portfolio, ssd) {
  return [
    ...portfolio.map((p) => ({ id: p.id, tipo: "portfolio", nome: p.nome })),
    ...ssd.map((s) => ({ id: s.id, tipo: "pipeline", nome: s.nome })),
  ];
}
